(function() {
  'use strict';

  angular
    .module('contentPlayer.contentPlayerHeaderDirective', ['contentPlayer.contentPlayerHeaderCtrl'])
    .directive('mfContentPlayerHeader', mfContentPlayerHeader);

  mfContentPlayerHeader.$inject = [];

  function mfContentPlayerHeader() {
    return {
      scope: {
        cModuleTitle: '@'
      },
      controller: 'ContentPlayerHeaderCtrl',
      link: function(scope, iElement) {
      }
    }
  }
})();
